// components/Auth/LoginPage.jsx
import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, Text, Spinner } from "@fluentui/react-components";
import { loginRequest } from "../../authConfig";

export default function LoginPage() {
  const { instance, inProgress } = useMsal();
  const [loading, setLoading] = React.useState(false);
  // Staff arriving from a survey invitation email
  const isSurveyLink = window.location.pathname.startsWith("/my-surveys");

  const handleLogin = async () => {
    setLoading(true);
    try {
      await instance.loginPopup(loginRequest);
    } catch (err) {
      console.error("Login failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #001A3D 0%, #002D7A 40%, #0052CC 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      {/* Background circles */}
      <div style={{ position: "fixed", top: -100, right: -100, width: 400, height: 400, borderRadius: "50%", background: "rgba(255,255,255,0.04)", pointerEvents: "none" }} />
      <div style={{ position: "fixed", bottom: -150, left: -100, width: 500, height: 500, borderRadius: "50%", background: "rgba(255,255,255,0.03)", pointerEvents: "none" }} />

      <div
        style={{
          background: "#fff",
          borderRadius: 24,
          padding: "48px 40px",
          width: "100%",
          maxWidth: 420,
          boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
          textAlign: "center",
        }}
      >
        {/* Logo */}
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: 20,
            background: "linear-gradient(135deg, #0052CC, #0066FF)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
            boxShadow: "0 8px 24px rgba(0,82,204,0.3)",
          }}
        >
          <Text style={{ color: "#fff", fontWeight: 800, fontSize: 24, letterSpacing: -1 }}>LO</Text>
        </div>

        <Text weight="bold" style={{ fontSize: 22, color: "#201F1E", display: "block", marginBottom: 4 }}>
          {isSurveyLink ? "LekOil Staff Survey" : "LekOil SCM Dashboard"}
        </Text>
        <Text style={{ color: "#605E5C", fontSize: 14, display: "block", marginBottom: 32 }}>
          {isSurveyLink ? "Sign in to open the survey shared with you" : "Supply Chain Management Portal"}
        </Text>

        <div
          style={{
            background: "#F3F2F1",
            borderRadius: 12,
            padding: "16px 20px",
            marginBottom: 28,
            textAlign: "left",
          }}
        >
          {(isSurveyLink ? [
            "📝 Takes only a few minutes",
            "🔒 Secured by your Microsoft 365 account",
            "✅ Submit once — your answers are saved instantly",
            "💬 Your feedback shapes how we work",
          ] : [
            "📊 Real-time SCM analytics",
            "📄 Contract & PO tracking",
            "⛽ Diesel inventory management",
            "🚚 Logistics performance",
          ]).map((item, i) => (
            <Text key={i} style={{ display: "block", fontSize: 13, color: "#323130", marginBottom: i < 3 ? 8 : 0, lineHeight: 1.5 }}>
              {item}
            </Text>
          ))}
        </div>

        <Button
          appearance="primary"
          size="large"
          onClick={handleLogin}
          disabled={loading || inProgress !== "none"}
          icon={loading ? <Spinner size="tiny" /> : (
            <svg width="18" height="18" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#F25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
              <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
            </svg>
          )}
          style={{
            width: "100%",
            background: "#0052CC",
            height: 48,
            fontSize: 15,
            fontWeight: 600,
            borderRadius: 10,
          }}
        >
          {loading ? "Signing in..." : "Sign in with Microsoft"}
        </Button>

        <Text style={{ color: "#8A8886", fontSize: 11, marginTop: 20, display: "block" }}>
          Sign in with your organizational Microsoft 365 account.
          <br />Secured by Azure Active Directory.
        </Text>
      </div>
    </div>
  );
}
